import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { localizeProduct } from "../utils/mapWooProduct";

export function useLocalizedProduct(product) {
  const { i18n } = useTranslation();

  return useMemo(
    () => localizeProduct(product, i18n.language),
    [product, i18n.language],
  );
}

export function useLocalizedProducts(products = []) {
  const { i18n } = useTranslation();

  return useMemo(
    () => products.map((product) => localizeProduct(product, i18n.language)),
    [products, i18n.language],
  );
}
